import styled, { css } from 'styled-components';
// @ts-ignore
import Plank from '@ertelecom/ui-react/components/plankInfo';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import { BaseButton } from '@ertelecom/ui-react/components/buttons/baseButton';

export const Button = styled(BaseButton)`
    width: 100%;
`;

export const WrapperContainer = styled.div<{ plAvailable?: boolean }>`
    width: 100%;
    margin-top: -28px;
    
    ${p => p.plAvailable
    ? css`
        background: radial-gradient(63.45% 90.07% at 28.3% 105.36%, #ED3D3D 0%, rgba(237, 61, 61, 0) 100%), linear-gradient(105.23deg, #DFF74E 15.62%, #FA00FF 106.65%);
        
        @media(max-width: 640px) {
            width: 100%;
        }
        
        & > div {
            flex-direction: row;
            
            @media(max-width: 1280px) {
                width: 100%;
            }
            
            @media(max-width: 1024px) {
                margin: 0;
                padding: 0;
            }
            
            @media(max-width: 380px) {
                min-width: auto;
            }
        }
        
        & > div > div:first-child {
            justify-content: flex-start;
            width: auto;
            
            @media(max-width: 1280px) {
                display: block;
                max-width: 536px;
                margin: auto;
            }
            
            @media(max-width: 860px) {
                padding: 10px;
            }
            
            @media(max-width: 380px) {
                width: 100%;
            }
            
            & > div {
                margin-left: 0;
                border-radius: 14px;
                max-width: 536px;
                padding: 50px 0;
                
                @media(max-width: 1024px) {
                    margin-right: 0;
                    max-width: 100%;
                }
                
                @media(max-width: 640px) {
                    padding: 30px 20px;
                }
            }
        }
    `
    : null};
`;

export const PlContainer = styled.div`
    display: block;
    margin-left: auto;
    align-self: center;
    
    @media(max-width: 1600px) {
        max-width: 400px;
    }
    
    @media(max-width: 1280px) {
        max-width: 100%;
        margin: 0 auto 50px;
    }
    
    a {
        display: block;
        margin: auto;
        background: rgba(255, 255, 255, .3);
        max-width: 266px;
        text-align: center;
        padding: 15px 65px;
        color: ${COLORS.white};
        border-radius: 4px;
        ${FONTS.Medium};
    }
    
    img {
        @media(max-width: 640px) {
            width: 100%;
        }
    }
`;

export const StyledPlank = styled(Plank)`
    margin-top: 15px;
    margin-bottom: 15px;
`;

export const Container = styled.div`
    width: 100%;
    ${FONTS.S};
    justify-content: center;
    text-align: center;
    padding: 0 90px;
    @media (max-width: 1024px) {
        padding: 0 50px;
    }
    @media (max-width: 640px) {
        justify-content: flex-start;
        text-align: left;
        padding: 0;
    }
`;

export const Header = styled.h1`
    ${FONTS.H2};
    margin: 0;
    @media (max-width: 640px) {
        ${FONTS.H3};
    }
`;

export const GreyBaseText = styled.div`
    color: #979797;
    ${FONTS.XS};
`;

export const GreyText = styled(GreyBaseText)`
    display: block;
    margin: 0 auto 20px;
    text-align: center;
    @media (max-width: 640px) { 
        text-align: left;
    }
`;

export const GreyLink = styled(GreyBaseText)`
    text-decoration: underline;
`;
